import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function safeJsonParse(data: any) {
  if (!data) return {};
  if (typeof data !== "string") return data;

  try {
    return JSON.parse(data);
  } catch (e) {
    console.error("Failed to parse config:", e, data);
    return {};
  }
}

export function openInNewTab(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}
